import React from 'react';
import { usePageTransition } from '../context/PageTransitionContext';
import './PageTransition.css';

// Wrapper qui applique une classe CSS selon l'état de transition.
// Les animations réelles (opacity, translate...) sont définies dans
// PageTransition.css sur les classes page-exit / page-enter / page-visible.
function PageTransition({ children }) {
  const { isExiting, isEntering } = usePageTransition();

  const getClassName = () => {
    if (isExiting) return 'page-transition page-exit';
    if (isEntering) return 'page-transition page-enter';
    return 'page-transition page-visible';
  };

  return (
    <div className={getClassName()}>
      {children}
    </div>
  );
}

export default PageTransition;
